import React from 'react';
import ReactMarkdown from 'react-markdown';
import NumberedStep from '../ui/NumberedStep';
import { colors } from '../../styles/theme';

interface FAQAnswerProps {
  answer: string;
}

const FAQAnswer: React.FC<FAQAnswerProps> = ({ answer }) => {
  // Fonction pour traiter le texte et extraire les étapes numérotées
  const processSteps = (text: string) => {
    const steps = text.split('\n').filter(line => /^\d+\./.test(line.trim()));
    if (steps.length > 0) {
      return (
        <div className="space-y-2 my-3">
          {steps.map((step, index) => {
            const content = step.replace(/^\d+\.\s*/, '').trim();
            return (
              <NumberedStep key={index} number={index + 1} color={colors.primary}>
                {content}
              </NumberedStep>
            );
          })}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="text-gray-600 leading-relaxed">
      <ReactMarkdown
        components={{
          a: ({ href, children }) => (
            <a 
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#0139B7] hover:underline inline-flex items-center"
            >
              {children}
            </a>
          ),
          strong: ({ children }) => (
            <strong className="font-semibold text-gray-900">{children}</strong>
          ),
          ul: ({ children }) => (
            <ul className="space-y-2 my-3">
              {children}
            </ul>
          ),
          li: ({ children, ordered }) => {
            if (ordered) {
              return null; // Les éléments ordonnés sont gérés par processSteps
            }
            return (
              <li className="flex items-center space-x-2">
                <span 
                  className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                  style={{ backgroundColor: colors.primary }}
                />
                <span>{children}</span>
              </li>
            );
          },
          p: ({ children }) => {
            const content = React.Children.toArray(children).join('');
            const stepsContent = processSteps(content);
            if (stepsContent) {
              return stepsContent;
            }
            // Ne rend le paragraphe que s'il contient du contenu
            if (!content || content.trim() === '') {
              return null;
            }
            return <p className="mb-3 last:mb-0">{children}</p>;
          }
        }}
      >
        {answer}
      </ReactMarkdown>
    </div>
  );
};

export default FAQAnswer;